const HEREMAP_APIKEY1 = "phekBZ2McK-NRA3qrm5usPx7bZ_N7_ZCk2pDxRLwuAs";
const HEREMAP_APIKEY2 = "5r-KsXKW1Z1cP93m6CZ8VERnTUBqaasR31KNtw_jHO4";
const hereChoice = Math.round(Math.random());
const HEREMAP_APIKEY = hereChoice ? HEREMAP_APIKEY1 : HEREMAP_APIKEY2;

// const localEnv: string = "prod";
// const localEnv: string = "staging";
const localEnv: string = "dev";

let testMode: boolean = false;
let testHostname: string;

export function setTestMode(test: boolean) {
    testMode = test;
    testHostname = "localhost";
}

export function getTestMode(): boolean {
    return testMode;
}

export function envLocal(hostname: string) {
    // prod
    if (localEnv === "prod") {
        return {
            VUE_APP_GRAPHQL_HTTP: "http://localhost:4001/graphql",
            VUE_APP_BACKEND: "http://localhost:4001",
            VUE_APP_I18N_LOCALE: "fr",
            VUE_APP_I18N_FALLBACK_LOCALE: "fr",
            WSS_URL: "wss://o3o6x6ni44.execute-api.eu-west-3.amazonaws.com/prod",
            HEREMAP_APIKEY,
            AMPLIFY_CONFIG: getAmplifyConfig(hostname),
            DEV_MODE: true,
            ENABLE_COGNITO: true,
            COGNITO_USERPOOL_ID: "eu-west-3_h4LtXryGT",
            USER_PROVIDER_TABLE: "prod_bobbeeapp_user_sso_provider",
            environnement: "local",
        };
    }
    if (localEnv === "staging") {
        // staging
        return {
            VUE_APP_GRAPHQL_HTTP: "http://localhost:4000/graphql",
            VUE_APP_BACKEND: "http://localhost:4000",
            VUE_APP_I18N_LOCALE: "fr",
            VUE_APP_I18N_FALLBACK_LOCALE: "fr",
            WSS_URL: "wss://n67yaalmff.execute-api.eu-west-3.amazonaws.com/staging",
            HEREMAP_APIKEY,
            AMPLIFY_CONFIG: getAmplifyConfig(hostname),
            DEV_MODE: true,
            ENABLE_COGNITO: true,
            COGNITO_USERPOOL_ID: "eu-west-3_v2VDiH7Ba",
            USER_PROVIDER_TABLE: "staging_bobbeeapp_user_sso_provider",
            environnement: "local",
        };
    }
    return {
        VUE_APP_GRAPHQL_HTTP: "http://localhost:4000/graphql",
        VUE_APP_BACKEND: "http://localhost:4000",
        VUE_APP_I18N_LOCALE: "fr",
        VUE_APP_I18N_FALLBACK_LOCALE: "fr",
        WSS_URL: "wss://bf1x24kll6.execute-api.eu-west-3.amazonaws.com/dev",
        HEREMAP_APIKEY,
        AMPLIFY_CONFIG: getAmplifyConfig(hostname),
        DEV_MODE: true,
        ENABLE_COGNITO: true,
        COGNITO_USERPOOL_ID: "eu-west-3_yhCfYCf1G",
        USER_PROVIDER_TABLE: "dev_bobbeeapp_user_sso_provider",
        environnement: "local",
    };
}

function envProd(hostname) {
    return {
        VUE_APP_GRAPHQL_HTTP: `https://${hostname}/api/graphql`,
        VUE_APP_BACKEND: `https://${hostname}/api`,
        VUE_APP_I18N_LOCALE: "fr",
        VUE_APP_I18N_FALLBACK_LOCALE: "fr",
        WSS_URL: "wss://o3o6x6ni44.execute-api.eu-west-3.amazonaws.com/prod",
        HEREMAP_APIKEY,
        AMPLIFY_CONFIG: getAmplifyConfig(hostname),
        DEV_MODE: false,
        ENABLE_COGNITO: true,
        COGNITO_USERPOOL_ID: "eu-west-3_h4LtXryGT",
        USER_PROVIDER_TABLE: "prod_bobbeeapp_user_sso_provider",
        environnement: "production",
    };
}

function envStaging(hostname) {
    return {
        VUE_APP_GRAPHQL_HTTP: `https://${hostname}/api/graphql`,
        VUE_APP_BACKEND: `https://${hostname}/api`,
        VUE_APP_I18N_LOCALE: "fr",
        VUE_APP_I18N_FALLBACK_LOCALE: "fr",
        WSS_URL: "wss://n67yaalmff.execute-api.eu-west-3.amazonaws.com/staging",
        HEREMAP_APIKEY,
        AMPLIFY_CONFIG: getAmplifyConfig(hostname),
        DEV_MODE: true,
        ENABLE_COGNITO: true,
        COGNITO_USERPOOL_ID: "eu-west-3_v2VDiH7Ba",
        USER_PROVIDER_TABLE: "staging_bobbeeapp_user_sso_provider",
        SSO_GOOGLE_CLIENT_ID: "",
        environnement: "staging",
    };
}

function envDev(hostname) {
    return {
        VUE_APP_GRAPHQL_HTTP: `https://${hostname}/api/graphql`,
        VUE_APP_BACKEND: `https://${hostname}/api`,
        VUE_APP_I18N_LOCALE: "fr",
        VUE_APP_I18N_FALLBACK_LOCALE: "fr",
        WSS_URL: "wss://bf1x24kll6.execute-api.eu-west-3.amazonaws.com/dev",
        HEREMAP_APIKEY,
        AMPLIFY_CONFIG: getAmplifyConfig(hostname),
        DEV_MODE: true,
        ENABLE_COGNITO: true,
        COGNITO_USERPOOL_ID: "eu-west-3_yhCfYCf1G",
        USER_PROVIDER_TABLE: "dev_bobbeeapp_user_sso_provider",
        SSO_GOOGLE_CLIENT_ID: "",
        environnement: "dev",
    };
}

const getEnv = (inHostName: string = null) => {
    const hostname = inHostName || testHostname || globalThis.document?.location?.hostname;
    switch (hostname) {
        case "localhost": {
            return envLocal(hostname);
        }
        case "app.bobbee.co": {
            return envProd(hostname);
        }
        case "staging-app.bobbee.co": {
            return envStaging(hostname);
        }
        case "dev-app.bobbee.co": {
            console.log("getEnv case=", hostname);
            return envDev(hostname);
        }
        default: {
            console.error("getEnv default", hostname);
            return envDev("dev-app.bobbee.co");
        }
    }
};

const getAmplifyConfig = (hostname: string) => {
    switch (hostname) {
        case "localhost":
            if (localEnv === "prod") {
                return {
                    Auth: {
                        identityPoolId: "eu-west-3:30b9badd-568c-4f0f-ba43-94877c2a0b2a",
                        region: "eu-west-3",
                        userPoolId: "eu-west-3_h4LtXryGT",
                        userPoolWebClientId: "1tqlgsr891dmbj2hiklgts45uc",
                        authenticationFlowType: "USER_SRP_AUTH",
                        oauth: {
                            scope: ["openid", "profile", "email", "aws.cognito.signin.user.admin"],
                            domain: "prod-bobbee-secure.auth.eu-west-3.amazoncognito.com",
                            redirectSignIn: "http://localhost:8080/redirect-sso",
                            redirectSignOut: "http://localhost:8080/redirect-sso",
                            responseType: "code",
                        },
                    },
                };
            }
            if (localEnv === "staging") {
                return {
                    Auth: {
                        identityPoolId: "eu-west-3:1acfed8e-a8d0-4ac1-b07e-db0dedde44bb",
                        region: "eu-west-3",
                        userPoolId: "eu-west-3_v2VDiH7Ba",
                        userPoolWebClientId: "73itia2kpmljm48o1ptgperqkm",
                        authenticationFlowType: "USER_SRP_AUTH",
                        oauth: {
                            scope: ["openid", "profile", "email", "aws.cognito.signin.user.admin"],
                            domain: "staging-bobbee-secure.auth.eu-west-3.amazoncognito.com",
                            redirectSignIn: "http://localhost:8080/redirect-sso",
                            redirectSignOut: "http://localhost:8080/redirect-sso",
                            responseType: "code",
                        },
                    },
                };
            }

            return {
                Auth: {
                    identityPoolId: "eu-west-3:89a13b67-2586-4e52-a258-8fb0fc97a57c",
                    region: "eu-west-3",
                    userPoolId: "eu-west-3_yhCfYCf1G",
                    userPoolWebClientId: "ijom0tgri9eug74n2ioado4be",
                    authenticationFlowType: "USER_SRP_AUTH",
                    oauth: {
                        scope: ["openid", "profile", "email", "aws.cognito.signin.user.admin"],
                        domain: "dev-bobbee-secure.auth.eu-west-3.amazoncognito.com",
                        redirectSignIn: "http://localhost:8080/redirect-sso",
                        redirectSignOut: "http://localhost:8080/redirect-sso",
                        responseType: "code",
                    },
                },
            };

        case "dev-app.bobbee.co":
            return {
                Auth: {
                    identityPoolId: "eu-west-3:89a13b67-2586-4e52-a258-8fb0fc97a57c",
                    region: "eu-west-3",
                    userPoolId: "eu-west-3_yhCfYCf1G",
                    userPoolWebClientId: "ijom0tgri9eug74n2ioado4be",
                    authenticationFlowType: "USER_SRP_AUTH",
                    oauth: {
                        scope: ["openid", "profile", "email", "aws.cognito.signin.user.admin"],
                        domain: "dev-bobbee-secure.auth.eu-west-3.amazoncognito.com",
                        redirectSignIn: "https://dev-app.bobbee.co/redirect-sso",
                        redirectSignOut: "https://dev-app.bobbee.co/redirect-sso",
                        responseType: "code",
                    },
                },
            };
        case "staging-app.bobbee.co":
            return {
                Auth: {
                    identityPoolId: "eu-west-3:1acfed8e-a8d0-4ac1-b07e-db0dedde44bb",
                    region: "eu-west-3",
                    userPoolId: "eu-west-3_v2VDiH7Ba",
                    userPoolWebClientId: "73itia2kpmljm48o1ptgperqkm",
                    authenticationFlowType: "USER_SRP_AUTH",
                    oauth: {
                        scope: ["openid", "profile", "email", "aws.cognito.signin.user.admin"],
                        domain: "staging-bobbee-secure.auth.eu-west-3.amazoncognito.com",
                        redirectSignIn: "https://staging-app.bobbee.co/redirect-sso",
                        redirectSignOut: "https://staging-app.bobbee.co/redirect-sso",
                        responseType: "code",
                    },
                },
            };
        case "app.bobbee.co":
            return {
                Auth: {
                    identityPoolId: "eu-west-3:30b9badd-568c-4f0f-ba43-94877c2a0b2a",
                    region: "eu-west-3",
                    userPoolId: "eu-west-3_h4LtXryGT",
                    userPoolWebClientId: "1tqlgsr891dmbj2hiklgts45uc",
                    authenticationFlowType: "USER_SRP_AUTH",
                    oauth: {
                        scope: ["openid", "profile", "email", "aws.cognito.signin.user.admin"],
                        domain: "prod-bobbee-secure.auth.eu-west-3.amazoncognito.com",
                        redirectSignIn: "https://app.bobbee.co/redirect-sso",
                        redirectSignOut: "https://app.bobbee.co/redirect-sso",
                        responseType: "code",
                    },
                },
            };
        default:
            return null;
    }
};

export default getEnv;
